import { useEffect, useState } from "react";

const useImageSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const returnActiveClass = (index: number) => {
    return index === currentIndex ? "active" : "";
  };

  useEffect(() => {
    const carousels = document.querySelectorAll(".carousel-item");
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex + 1 === carousels.length ? 0 : prevIndex + 1
      );
    }, 6000);
    return () => clearInterval(intervalId);
  }, []);
  return { returnActiveClass };
};

export default useImageSlider;
